import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ShieldCheck } from 'lucide-react';
import V2Layout from './V2Layout';

export default function PrivacyPolicyV2() {
  const { t } = useTranslation();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const list = (key) => {
    const items = t(key, { returnObjects: true });
    if (!Array.isArray(items)) return null;
    return (
      <ul className="v2-legal-list">
        {items.map((item, idx) => <li key={idx}>{item}</li>)}
      </ul>
    );
  };

  return (
    <V2Layout>
      <section className="v2-legal-hero">
        <div className="v2-container">
          <span className="v2-pill"><ShieldCheck /> {t('footer.legal_privacy')}</span>
          <h1>{t('legal.privacy.title')}</h1>
          <p className="v2-legal-date">{t('legal.privacy.last_update')}</p>
        </div>
      </section>

      <section className="v2-legal-wrap">
        <div className="v2-container">
          <article className="v2-legal-card">
            <section>
              <h2>{t('legal.privacy.intro_title')}</h2>
              <p className="v2-legal-pre">{t('legal.privacy.intro')}</p>
            </section>

            <section>
              <h2>{t('legal.privacy.controller_title')}</h2>
              <p className="v2-legal-pre">{t('legal.privacy.controller')}</p>
            </section>

            <section>
              <h2>{t('legal.privacy.data_title')}</h2>
              <h3>{t('legal.privacy.account_data_title')}</h3>
              {list('legal.privacy.account_data')}
              <h3>{t('legal.privacy.tech_data_title')}</h3>
              {list('legal.privacy.tech_data')}
              <h3>{t('legal.privacy.not_collected_title')}</h3>
              {list('legal.privacy.not_collected')}
            </section>

            <section>
              <h2>{t('legal.privacy.zero_data_title')}</h2>
              {list('legal.privacy.zero_data')}
            </section>

            <section>
              <h2>{t('legal.privacy.purpose_title')}</h2>
              {list('legal.privacy.purpose')}
            </section>

            <section>
              <h2>{t('legal.privacy.legal_basis_title')}</h2>
              {list('legal.privacy.legal_basis')}
            </section>

            <section>
              <h2>{t('legal.privacy.retention_title')}</h2>
              {list('legal.privacy.retention')}
            </section>

            <section>
              <h2>{t('legal.privacy.sharing_title')}</h2>
              {list('legal.privacy.sharing')}
              <p className="v2-legal-muted">{t('legal.privacy.no_selling')}</p>
            </section>

            <section>
              <h2>{t('legal.privacy.transfer_title')}</h2>
              <p>{t('legal.privacy.transfer_content')}</p>
              {list('legal.privacy.transfer')}
            </section>

            <section>
              <h2>{t('legal.privacy.security_title')}</h2>
              {list('legal.privacy.security')}
            </section>

            <section>
              <h2>{t('legal.privacy.rights_title')}</h2>
              {list('legal.privacy.rights')}
              <p className="v2-legal-muted">{t('legal.privacy.rights_contact')}</p>
            </section>

            <section>
              <h2>{t('legal.privacy.cookies_title')}</h2>
              <h3>{t('legal.privacy.essential_cookies')}</h3>
              {list('legal.privacy.essential_cookies_list')}
              <h3>{t('legal.privacy.analytics_cookies')}</h3>
              {list('legal.privacy.analytics_cookies_list')}
              <p className="v2-legal-muted">{t('legal.privacy.cookies_manage')}</p>
            </section>

            <section>
              <h2>{t('legal.privacy.minors_title')}</h2>
              <p>{t('legal.privacy.minors')}</p>
            </section>

            <section>
              <h2>{t('legal.privacy.changes_title')}</h2>
              <p>{t('legal.privacy.changes')}</p>
            </section>

            <section>
              <h2>{t('legal.privacy.contact_title')}</h2>
              {list('legal.privacy.contact')}
              <p className="v2-legal-pre v2-legal-muted">{t('legal.privacy.cnil')}</p>
            </section>

            <section>
              <h2>{t('legal.privacy.privacy_by_design_title')}</h2>
              {list('legal.privacy.privacy_by_design')}
              <p className="v2-legal-highlight v2-grad-text">{t('legal.privacy.privacy_by_design_footer')}</p>
            </section>
          </article>
        </div>
      </section>
    </V2Layout>
  );
}
